import { date_on_calendar_click } from "packs/custom_js/functions/shared/shared.js"
$(document).on("turbolinks:load",function(){
	$("#function_1_1, #function_2_1, #function_4_1, #function_4_2, #function_4_3, #function_4_4, #function_4_5, #function_5_1, #function_5_2, #function_6_1, #function_7_1").each(function() {
		date_on_calendar_click(this);
	}); 
});